module.exports = __webpack_public_path__ + "img/ic-check-white.svg";